/**
 * 数据引导国际化
 * date：2022 07 22
 */
export default {
    analysis: {
        offline_rate: 'Offline Rate',
        pass_rate: 'Pass Rate',
        data: 'Historical Records',
        dataAndChart: 'Data&Curve',
        line: 'Line Chart'
    }
};
